import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  Card,
  Row,
  Col,
  DatePicker,
  Table,
  message,
  Modal,
  Form,
  Typography,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons"; // Import DownloadOutlined icon
import "./Styles/staffManagement.css"; // Assuming you have a CSS file for styling
import axios from "axios"; // Import Axios
import moment from "moment";
import * as XLSX from "xlsx"; // Import XLSX
import CommissionOrderModel from "./CommissionOrdersModel"; // Import the OrderDetailsModal component

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { confirm } = Modal; // Import Modal.confirm
const { Link } = Typography;

const Dashboard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedOrder2, setSelectedOrder2] = useState(null);
  const [vendorId, setVendorId] = useState("");
  const [dataSource, setDataSource] = useState([]); // Set initial data source

  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState([]);

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await fetch("https://app-tl2d3sc25q-uc.a.run.app/api/vendor_list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch vendor list");
      }
      const data = await response.json();

      // Filter out orders that are already assigned (based on order_id)
      console.log("vendorList", data);
      setOrderData(data); // Update orderData state with unassigned orders
    } catch (error) {
      console.error("Error fetching unshipped orders:", error);
      // Handle error state if needed
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "order_id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Vendor Id",
      dataIndex: "vendor_id",
      key: "vendor_id",
    },
    {
      title: "Vendor Name",
      dataIndex: "vendor_name",
      key: "vendor_name",
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "Store Phone",
      dataIndex: "store_phone",
      key: "store_phone",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => showAssignModal2(record)}>
          View
        </Button>
      ),
    },
  ];

  const formatDate = (dateString) => {
    console.log("come");
    // Use Moment.js or JavaScript Date object to format the date
    const formattedDate = moment(dateString).format("DD:MM:YYYY hh:mm A");
    return formattedDate;
  };

  const showAssignModal2 = (record) => {
    console.log("showAssignModal2 called with record:", record);
    handleearnings(record);
    setVendorId(record.vendor_id);
  };

  const handleearnings = async (record) => {
    try {
      const response = await axios.post(
        "https://app-tl2d3sc25q-uc.a.run.app/api/earnings_calc",
        {
          vendorId: record.vendor_id,
        }
      );

      const data = response.data;
      console.log("Vendor Details:", data);
      setSelectedVendor(data); // Store vendor details in state
      console.log("Setting modal visibility to true");
      setIsModalVisible(true); // Show modal
    } catch (error) {
      console.error("Error fetching vendor details:", error);
      // Handle error state if needed
    }
  };

  // Ensure your QuanityProductModel component is properly configured to handle the 'visible' prop

  const handleDownload = () => {
    const formattedData = dataSource.map((item, index) => ({
      "S.No": index + 1,
      "Order Id": item.order_id,
      "Date & Time": moment(item.order_date).format("DD/MM/YYYY hh:mm A"),
      "Packed Date & Time": item.packed_time
        ? moment(item.packed_time).format("DD/MM/YYYY hh:mm A")
        : "N/A",
      "Shipped Date & Time": item.readytoship_time
        ? moment(item.readytoship_time).format("DD/MM/YYYY hh:mm A")
        : "N/A",
      "Pickup Date & Time": item.pickedup_time
        ? moment(item.pickedup_time).format("DD/MM/YYYY hh:mm A")
        : "N/A",
      "Customer Name": `${item.first_name} ${item.last_name}`,
      "Customer Phone": item.phone,
      Status: item.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order History");
    XLSX.writeFile(workbook, "Order_History.xlsx");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="dashboard-container">
      {/* <Row justify="space-between" align="middle">
        <Col>
          <RangePicker
            onChange={(dates, dateStrings) => {
              setStartDate(dateStrings[0]);
              setEndDate(dateStrings[1]);
            }}
          />
        </Col>
        <Col>
          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
          >
            Download
          </Button>
        </Col>
      </Row> */}
      <Row>
        <Col>
          <Table
            columns={columns}
            dataSource={orderData}
            rowKey="order_id"
            scroll={{ x: 1200, y: 500 }}
          />
        </Col>
      </Row>
      <CommissionOrderModel
        visible={isModalVisible}
        order={selectedVendor}
        onCancel={handleCancel}
        vendorId={vendorId}
      />
    </div>
  );
};

export default Dashboard;
